module.exports = function startBrowserSync(userPort, internalPort, opts) {
    let bs;
    try {
        bs = require('browser-sync').create();
    } catch {
        console.warn('[!] browser-sync is not installed, skipping hot-reload.');
        console.log('Server Running on http://localhost:' + userPort);
        return;
    }

    const config = Object.assign(
        {
            port: userPort,

            proxy: 'http://localhost:' + internalPort,

            ui: false,
            host: 'localhost',
            watch: true,
            files: opts.watch,
            notify: false,
            open: false,
            reloadDelay: 100,
            ghostMode: {
                clicks: true,
                scroll: true,
                forms: true
            },
            logLevel: 'info'
        },
        opts.browserSync
    );

    console.log('Server Running on http://localhost:' + userPort);
    console.log('[fullstx] Hot-reload active via browser-sync.');

    bs.init(config);
};
